"use strict";

class AFArray {
    constructor() {
    }

    free() {
    }

    elements() {
    }

    host() {
    }

    copyToHost() {
    }

    scalar() {
    }

    value() {
    }

    write() {
    }

    type() {
    }

    dims() {
    }

    numdims() {
    }

    numDims() {
    }

    bytes() {
    }

    copy() {
    }

    isempty() {
    }

    isEmpty() {
    }

    isscalar() {
    }

    isScalar() {
    }

    isvector() {
    }

    isVector() {
    }

    isrow() {
    }

    isRow() {
    }

    iscolumn() {
    }

    isColumn() {
    }

    iscomplex() {
    }

    isComplex() {
    }

    isreal() {
    }

    isReal() {
    }

    isdouble() {
    }

    isDouble() {
    }

    issingle() {
    }

    isSingle() {
    }

    isrealfloating() {
    }

    isRealFloating() {
    }

    isfloating() {
    }

    isFloating() {
    }

    isinteger() {
    }

    isInteger() {
    }

    isbool() {
    }

    isBool() {
    }

    afEval() {
    }

    at() {
    }

    row() {
    }

    col() {
    }

    slice() {
    }

    rows() {
    }

    cols() {
    }

    slices() {
    }

    as() {
    }

    assign() {
    }

    set() {
    }

    add() {
    }

    addAssign() {
    }

    sub() {
    }

    subAssign() {
    }

    mul() {
    }

    mulAssign() {
    }

    div() {
    }

    divAssign() {
    }

    bitshiftl() {
    }

    bitShiftL() {
    }

    bitshiftr() {
    }

    bitShiftR() {
    }

    lt() {
    }

    gt() {
    }

    le() {
    }

    ge() {
    }

    eq() {
    }

    neq() {
    }

    and() {
    }

    or() {
    }

    bitAnd() {
    }

    bitOr() {
    }

    bitXor() {
    }

    rhsAdd() {
    }

    rhsSub() {
    }

    rhsMul() {
    }

    rhsDiv() {
    }

    rhsBitshiftl() {
    }

    rhsBitShiftL() {
    }

    rhsBitshiftr() {
    }

    rhsBitShiftR() {
    }

    rhsLt() {
    }

    rhsGt() {
    }

    rhsLe() {
    }

    rhsGe() {
    }

    rhsEq() {
    }

    rhsNeq() {
    }

    rhsAnd() {
    }

    rhsOr() {
    }

    rhsBitAnd() {
    }

    rhsBitOr() {
    }

    rhsBitXor() {
    }

    neg() {
    }

    not() {
    }

    T() {
    }

    H() {
    }
}

AFArray.create = function() {
};

module.exports = AFArray;
